// extracted by mini-css-extract-plugin
export default {"entries":"DisplayMeasurementDetail_entries__lO3Lo"};